import { render } from "./Ethereum.vue?vue&type=template&id=5acbc1f2"
import script from "./Ethereum.vue?vue&type=script&lang=js"
export * from "./Ethereum.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__